var Util = require('utilities');

var routeContext = {};

var RC = (module.exports = {
	getParam: function (key) {
		return routeContext.params && routeContext.params[key];
	},

	getQuery: function (key) {
		return routeContext.parsedPath?.getQueryParam(key);
	},

	set: function (ctx) {
		routeContext = ctx;

		this.pathname = ctx.pathname;
		this.path = ctx.path;
		this.querystring = ctx.querystring;
	}
});

Util.defineProperty(RC, 'hashes', {
	get: function () {
		return routeContext.hashes || [];
	}
});

Util.defineProperty(RC, 'hash', {
	get: function () {
		return window.location.hash;
	}
});
